// extracted by mini-css-extract-plugin
module.exports = {"star":"Star-module_star_1ty7_","full":"Star-module_full_3M28Y","bg":"Star-module_bg_3HKcg"};